import { DateTime } from "@easepick/bundle";
import { isHoliday, Region } from "feiertagejs";

export const getHolidays = (
    regions: Region[],
    days: number = 365,
    startDate: DateTime = new DateTime(),
    with_sunday: boolean = true,
    with_saturday: boolean = false
): DateTime[] => {
    return [...Array(days).keys()]
        .map((i) => {
            return startDate.clone().add(i).toJSDate();
        })
        .filter((d) => {
            if (with_sunday && d.getDay() === 0) {
                return true;
            }
            if (with_saturday && d.getDay() === 6) {
                return true;
            }

            return regions.find((r) => isHoliday(d, r));
        })
        .map((d) => new DateTime(d));
};
